import styled from 'styled-components';
import * as mixins from 'view/styles/mixins';

interface FakeButtonContainerProps {
    isCursorGrab?: boolean;
}

const FakeButtonContainer = styled.div<FakeButtonContainerProps>`
    ${mixins.focusRing.default};
    display: inline-block;
    cursor: pointer;

    &[aria-disabled='true'] {
        ${mixins.focusRing.none};
        ${(props) => (props.isCursorGrab ? 'cursor: grab' : 'cursor: default')};
    }
`;

export default FakeButtonContainer;
